module.exports = __webpack_public_path__ + "static/media/without_astrnt.d3ce42f5.png";